import { TraceLoggingHelpers } from "../helpers/trace-logging-helpers";
import { IChartContainer } from "../models/base/chart-container.interface";
import { Timeframe } from "../models/enum/timeframe.enum";
import { IComponent } from "./component.interface";
import { TimeframeIconComponent } from "./menu/timeframe-icon.component";

export class PnPSwitchComponent implements IComponent {
    public id = '';

    private element: HTMLElement;
    private base: IChartContainer;

    public switched = false;
    
    private pipTimeframeBeforeSwitched = Timeframe.OneMinute;

    constructor(element: HTMLElement, base: IChartContainer) {
        this.element = element;
        this.base = base;
        this.onElementClick();
    }

    private onElementClick() {
        this.element.addEventListener('click', () => {
            this.togglePnPMode();
            this.requestTimeFrame();
        });
    }

    public togglePnPMode() {
        TraceLoggingHelpers.log(' togglePnPMode ')
        this.switched = !this.switched;
    }

    public requestTimeFrame() {
        const base = this.base as any;
        const pnpContainerChartService = base.pnpContainer?.chartService;
        const pnpChartTimeFrame = base.pnpContainer?.tiChartSeries?.currentTimeframe;
        if (this.switched) {
            this.pipTimeframeBeforeSwitched = pnpChartTimeFrame;
        }

        
        const mainChartTimeFrameIcon = this.base?.getComponentsByType(TimeframeIconComponent)[0] as TimeframeIconComponent;
        const pipTimeFrameIcon = base.pnpContainer?.getComponentsByType(TimeframeIconComponent)[0] as TimeframeIconComponent;
        const mainChartTimeFrame = base.tiChartSeries.currentTimeframe;

        const mainTimeFrameToSwap = this.base.chartService.getWindowFormTimeFrame(pnpChartTimeFrame);

        mainChartTimeFrameIcon?.setCurrentTimeframe(mainTimeFrameToSwap.formTimeFrame);
        this.base.chartService.requestNewTimeframe(mainTimeFrameToSwap.formTimeFrame);

        pipTimeFrameIcon?.setCurrentTimeframe(mainChartTimeFrame);
        pnpContainerChartService?.requestNewTimeframe(!this.switched ? this.pipTimeframeBeforeSwitched : mainChartTimeFrame);
        
        if (this.switched) {
            pipTimeFrameIcon?.hideTimespan();
        }
    }
}